// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"5ece5b42","386":"d58392bf"}[chunkId] + ".chunk.js";
};